<template>
    <v-container>
        <v-layout>
            <v-flex xs12 sm12 md12 lg12 px-2>
                <h1 style="text-align: center;">
                    <strong>Cookie Policy</strong>
                </h1><br>
                <h2 class="privacy__title">
                    Important information about consent
                </h2><br>
                <p class="para">
                    By using our website, applications, mobile app, or any other services we offer through the website
                    or email (“Services”), you consent to the use of cookies in accordance with this “Cookies Policy”.
                </p>
                <h2 class="privacy__title">
                    What are cookies?
                </h2><br>
                <p class="para">
                    Cookies are unique identifiers, usually made up of small bits of text or code. Cookies are usually
                    stored on your device or in your web browser. Cookies send certain information back to the party who
                    served the cookie.
                </p>
                <p class="para">
                    When we say cookies we are actually referring to a broader range of technologies than just cookies,
                    including web beacons, clear gifs, pixels and other similar technologies. When we say first-party
                    cookies we mean cookies that are served by Magnify Myanmar. When we say third party cookies we mean cookies
                    that are served by Magnify Myanmar parties.

                </p>
                <h2 class="privacy__title">
                    How are cookies used?
                </h2><br>
                <p class="para">
                    Cookies are used in order to better understand how applications and websites work and to optimize
                    online and mobile experiences. Cookies do this by allowing the party serving the cookie to analyse a
                    website’s or mobile app’s performance, to identify certain users and remember their preferences, to
                    better understand whether a computer or device (and probably its user) has visited a website
                    previously and to serve customised advertisements.

                </p>
                <h2 class="privacy__title">
                    What kinds of cookies are used on the Site?
                </h2><br>
                <p class="para">
                    Our website primarily uses the following four types of cookies:
                </p>
                <ol class="fact-list--style">
                    <li>
                        Operationally Necessary Cookies<br>
                        These cookies are essential for the operation of our website. They make it possible for you to
                        browse and use our website. If you disable these cookies, the website will not function
                        correctly.
                    </li>
                    <li>
                        Performance Cookies<br>
                        These cookies gather information about how visitors use and interact with our Services. For
                        example, performance cookies tell us which pages are popular, monitor traffic to our website and
                        compile anonymous analytic information. Performance cookies can also be used to identify and
                        remedy operational problems with the website.

                    </li>
                    <li>
                        Functionality Cookies<br>
                        These cookies are used to recognize and remember your preferences. For example, functionality
                        cookies may use information, such as your location, to make sure that you arrive at a version of
                        our Site that is specific to your city or region.

                    </li>
                    <li>
                        Advertising Cookies
                        <br>
                        These cookies are used to show relevant advertising about our Services on third party websites
                        (i.e. websites that we do not own or operate). When you visit our website, we will serve a
                        cookie on your device. This cookie will have information about how you interacted with our
                        website, such as what pages on the site you looked at. Then, if you visit a website within an ad
                        network that we work with, the ad network will read the cookie from your device and show you
                        relevant advertising about our Services.

                    </li>
                </ol>
                <br>
                <h2 class="privacy__title">
                    How can I avoid cookies?
                </h2><br>
                <p class="para">
                    You may be able to avoid certain cookies by configuring your browser settings or opting-out directly
                    with the party that operates and controls the cookie. Please check your browser settings for more
                    information.
                </p>
                <p class="para">
                    In addition, you can opt-out of third-party personalised advertising cookies (but please note you
                    will still be served online advertisements). To learn more or to opt-out of the use of such
                    third-party personalised advertising cookies in the EU, please visit <a href="http://www.youronlinechoices.eu/" target="_blank">youronlinechoices.eu</a>.
                    If you are based in the United States, please visit <a href="http://www.aboutads.info/choices/" target="_blank">aboutads.info/choices</a>.
                </p><br>
                <h2 class="privacy__title">
                    Are there cookies in emails?
                </h2><br>
                <p class="para">
                    Our emails contain cookies that track whether you open our emails and whether you click any links
                    within them. The cookies used in our emails to monitor these behaviours are unique to each email.
                    They are not stored on your computer or mobile device.
                </p><br>
                <h2 class="privacy__title">
                    What if I have questions?
                </h2><br>
                <p class="para">
                    If after reading this Cookies Policy you have any questions please us at <a style="text-decoration: none;" href="mailto:contact@magnifymyanmar.com">contact@magnifymyanmar.com</a>
                </p>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
	export default {
		name: "CookiePolicy"
	}
</script>

<style scoped>
    @import '../../public/css/bootstrap.min.css';
    @import '../../public/css/bindez.css';
    @import '../../public/css/bindez-custom2.css';

    @font-face {
        font-family: 'icomoon';
        src: url('../../public/fonts/icomoon.eot');
        src: url('../../public/fonts/icomoon.eot') format('embedded-opentype'),
        url('../../public/fonts/icomoon.ttf') format('truetype'),
        url('../../public/fonts/icomoon.woff') format('woff'),
        url('../../public/fonts/icomoon.svg') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    [class^="icon-"],
    [class*=" icon-"] {
        /* use !important to prevent issues with browser extensions that change fonts */
        font-family: 'icomoon' !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;

        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .icon-burmese:before {
        content: "\e900";
    }

    .icon-data:before {
        content: "\e901";
    }

    .icon-real-time:before {
        content: "\e902";
    }

    #lp-container {
        background-color: #fff;
    }

    .custom-modal-size > * > * {
        height: 500px;
    }

    p.para {
        font-weight: 400;
        font-size: 20px;
        line-height: 1.8;
        margin-bottom: 16px;
    }

    a {
        text-decoration: none;
    }

    /*h2{*/
    /*    font-weight: 900;*/
    /*    font-size: 25px;*/
    /*    color: #000;*/
    /*}*/

    h1{
        margin-top: 80px;
        font-size: 28px;
        color: #000;
        /*line-height: 1.5;*/
    }

    h2.privacy__title {
        font-weight: 900;
        font-size: 25px;
        margin-bottom: 0;
        color: #000;
    }

    h2.privacy__sub-title {
        font-weight: 900;
        font-size: 23px;
        margin-bottom: 0;
        color: #000;
    }

    h3{
        color: #000;
        font-size: 16.38px;
        line-height: normal;
        font-weight: 900;
    }

    .fact-list--style {
        font-weight: 400;
        font-size: 20px;
    }

    .fact-list--style > li {
        line-height: 1.8;
    }

</style>
